import React, { FC, PropsWithChildren, useRef, useEffect } from 'react';

import { PlayerController } from '@/scenarios/legacy-player/components/PlayerController/PlayerController';
import { useFilmoscope } from '@/scenarios/legacy-player/hooks/filmoscope/useFilmoscope';
import { PlayerProvider } from '@/scenarios/legacy-player/lib/contexts/instance';
import { PlayerViewProvider } from '@/scenarios/legacy-player/lib/contexts/view';
import { createPlayerConfigProps } from '@/scenarios/legacy-player/lib/createPlayerConfigProps';
import { PlayerConfig } from '@/scenarios/legacy-player/types/config';
import { PlayerApiError } from '@/scenarios/legacy-player/types/instance';

interface Props {
    config: PlayerConfig;
    useYasp?: boolean;
    useSDKConfig?: boolean;
    onLoadingError?: (error: PlayerApiError) => void;
}

export const Filmoscope: FC<PropsWithChildren<Props>> = ({
    children,
    config,
    useYasp,
    useSDKConfig,
    onLoadingError,
}) => {
    const playerViewRef = useRef<HTMLDivElement>(null);
    const instance = useFilmoscope({ onLoadingError, config, useYasp, useSDKConfig });

    useEffect(() => {
        if (playerViewRef.current && instance?.type === 'filmoscope') {
            instance?.moveToContainer(playerViewRef.current);
        }
    }, [instance]);

    const playerConfigProps = createPlayerConfigProps(config);

    return (
        <PlayerProvider value={instance}>
            <PlayerViewProvider value={playerViewRef}>
                <PlayerController {...playerConfigProps} />
                {children}
            </PlayerViewProvider>
        </PlayerProvider>
    );
};
